var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMinimizeMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35,14c-0.5517578,0-1-0.4482422-1-1V4h-2v9c0,1.6542969,1.3457031,3,3,3h9v-2H35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,13c0,0.5517578-0.4482422,1-1,1H4v2h9c1.6542969,0,3-1.3457031,3-3V4h-2V13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,32H4v2h9c0.5517578,0,1,0.4482422,1,1v9h2v-9C16,33.3457031,14.6542969,32,13,32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,35v9h2v-9c0-0.5517578,0.4482422-1,1-1h9v-2h-9C33.3457031,32,32,33.3457031,32,35z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimizeMedium);
export default __webpack_public_path__ + "static/media/minimize--medium.a9e202271b6d4efe53f68267ef3e8941.svg";
export { ForwardRef as ReactComponent };